import state from './moduleVesselReportViewState.js'
import mutations from './moduleVesselReportViewMutations.js'
import actions from './moduleVesselReportViewActions.js'
import getters from './moduleVesselReportViewGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
